export default __webpack_public_path__ + "static/0290-e4d88000e495ebb9b36d544a2d681ca8.png";